/* eslint-disable import/no-absolute-path */
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import Icon from '../components/Icon';

// eslint-disable-next-line no-confusing-arrow
const getColor = (focused, theme, isMuicon = false) => (!focused
  ? 'rgba(255,255,255, 0.7)'
  : isMuicon ? 'primary' : theme.PRIMARY_COLOR);

const drawerItems = [
  {
    id: '0',
    label: 'Home',
    path: '/',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Home" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: 's-20',
    label: 'Simulator',
    path: '/simulator',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Money" color={getColor(focused, theme)} width={16} height={16} />
    ),

  },

  {
    id: '1',
    label: 'Top Gamers',
    path: '/leaderboard',
    isProduct: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Trophy" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '2',
    label: 'Game Rules',
    path: '/memegame-rules',
    isProduct: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Star" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: 's-21',
    label: 'Simulator Rules',
    path: '/simulator-rules',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Star" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '17',
    label: 'Challenge Guidelines',
    path: '/blog/post/challenge-guidelines',
    isProduct: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Dice" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '3',
    label: 'Coin Packs',
    path: '/packages',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Memberships" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  // {
  //   id: '4',
  //   label: 'Redeem Tokens',
  //   path: '/redeem-token',
  //   roles: ['all'],
  //   isProduct: true,
  //   icon: (focused, theme) => (
  //     <Icon name="MoneyHand" color={getColor(focused, theme)} width={16} height={16} />
  //   ),
  // },
  {
    id: '5',
    label: 'Game History',
    path: '/game-history',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="ClockArrow" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: 'my-coin-picks',
    label: 'My Coin Picks',
    path: '/my-coin-picks',
    isProduct: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <AdsClickIcon color={getColor(focused, theme, true)} fontSize="small" />
    ),
  },
  {
    id: '16',
    label: 'Booster Leads',
    path: '/booster-leads',
    roles: ['admin'],
    icon: (focused, theme) => (
      <Icon name="ArrowDotsUp" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },

  {
    id: 's-0',
    label: 'Admin Simulator',
    isAffiliate: true,
    isProduct: true,
    noPath: true,
    roles: ['admin', 'superadmin', 'owner', 'root'],
    icon: (focused, theme) => (
      <Icon name="Money" color={getColor(focused, theme)} width={16} height={16} />
    ),
    children: [
      {
        id: 's-22',
        label: 'Rules',
        path: '/simulator-admin/rules',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: 's-23',
        label: 'Settings',
        path: '/simulator-admin/settings',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
    ],
  },
  {
    id: '6',
    label: 'Admin',
    isAffiliate: true,
    isProduct: true,
    noPath: true,
    roles: ['admin', 'superadmin', 'owner', 'root', 'support'],
    icon: (focused, theme) => (
      <Icon name="Admin" color={getColor(focused, theme)} width={16} height={16} />
    ),
    children: [

      {
        id: '6-a',
        label: 'Member Admin',
        path: '/admin/members',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-a1',
        label: 'Support',
        path: '/admin/support',
        roles: ['admin', 'superadmin', 'owner', 'root', 'support'],
      },
      {
        id: '6-b',
        label: 'Packs',
        path: '/admin/passes',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-c',
        label: 'Bundles',
        path: '/admin/packages',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-d',
        label: 'Pack Types',
        path: '/admin/pass-types',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-e',
        label: 'Ranks',
        path: '/admin/ranks',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-f',
        label: 'Meme Coins',
        path: '/admin/meme-coins',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-g',
        label: 'Meme Games',
        path: '/admin/meme-games',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-h',
        label: 'Descriptions History',
        path: '/admin/descriptions-history',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-i',
        label: 'Game Payouts',
        path: '/admin/payouts',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-j',
        label: 'Send Email',
        path: '/admin/send-email',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-k',
        label: 'Pending Withdrawals',
        path: '/admin/pending-withdrawals',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-l',
        label: 'Pending Redemptions',
        path: '/admin/pending-redemptions',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-m',
        label: 'Videos Administration',
        path: '/admin/videos',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-n',
        label: 'Booster Lead Admin',
        path: '/admin/booster-program',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-o',
        label: 'Global Banner',
        path: '/admin/global-banner',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-p',
        label: 'Global Notify',
        path: '/admin/global-notify',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-q',
        label: 'FAQs',
        path: '/admin/faq',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-r',
        label: 'Blog',
        path: '/admin/b/posts',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '6-s',
        label: 'Transactions',
        path: '/admin/transactions',
        roles: ['admin', 'superadmin', 'owner', 'root', 'support'],
      },
      {
        id: '6-t',
        label: 'Tax Forms',
        path: '/admin/tax-forms',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
    ],
  },
  {
    id: '15',
    label: 'Admin Reports',
    isAffiliate: true,
    isProduct: true,
    noPath: true,
    roles: ['admin', 'superadmin', 'owner', 'root'],
    icon: (focused, theme) => (
      <Icon name="ReportFile" color={getColor(focused, theme)} width={16} height={16} />
    ),
    children: [
      {
        id: '15-a',
        label: 'Usage Report',
        path: '/admin/reports/usage',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '15-b',
        label: 'Sales Report',
        path: '/admin/reports/sales-report',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '15-c',
        label: 'Game Results Report',
        path: '/admin/reports/game-results',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '15-d',
        label: 'Webinar Leads',
        path: '/admin/reports/webinar',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
      {
        id: '15-e',
        label: 'MemeGamer Challenge',
        path: '/admin/reports/challenge',
        roles: ['admin', 'superadmin', 'owner', 'root'],
      },
    ],
  },
  {
    id: '8',
    label: 'Genealogy',
    isAffiliate: true,
    noPath: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Genealogy" color={getColor(focused, theme)} width={16} height={16} />
    ),
    children: [
      {
        id: '8-a',
        label: 'Personals',
        path: '/sales/list',
        roles: ['all'],
      },
      {
        id: '8-b',
        label: 'Team',
        path: '/sales/tree',
        roles: ['all'],
      },
    ],
  },
  {
    id: '9',
    label: 'Gamer Wallet',
    path: '/gamer-wallets',
    noPath: true,
    roles: ['all'],
    isProduct: true,
    isAffiliate: false,
    icon: (focused, theme) => (
      <Icon name="Wallets" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '10',
    label: 'Ambassador Wallet',
    path: '/ambassador-wallets',
    roles: ['all'],
    isProduct: false,
    isAffiliate: true,
    icon: (focused, theme) => (
      <Icon name="Wallets" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '11',
    label: 'Wallets',
    isAffiliate: true,
    isProduct: true,
    noPath: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Wallets" color={getColor(focused, theme)} width={16} height={16} />
    ),
    children: [
      {
        id: '11-a',
        label: 'Ambassador Wallet',
        path: '/ambassador-wallets',
        roles: ['all'],
      },
      {
        id: '11-b',
        label: 'Gamer Wallet',
        path: '/gamer-wallets',
        roles: ['all'],
      },
    ],
  },
  {
    id: '12',
    label: 'Profile',
    path: '/profile',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Profile" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '13',
    label: 'Legacy Comp Plan',
    path: '/comp-plan',
    isAffiliate: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Dollar" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
  {
    id: '18',
    label: 'Resources',
    noPath: true,
    roles: ['all'],
    icon: (focused, theme) => (
      <InfoOutlinedIcon
        sx={{ fontSize: '16px' }}
        name="Genealogy"
        color={getColor(focused, theme)}
        width={14}
        height={14}
      />
    ),
    children: [
      {
        id: '18-a',
        label: 'Deck',
        roles: ['all'],
        file: {
          href: 'https://s3.amazonaws.com/cdn.memegames.ai/downloads/mgdeck.pdf',
          download: 'deck.pdf',
        },
      },
      {
        id: '18-b',
        label: 'Opportunity Zoom',
        path: '/blog/post/opportunity-zooms',
        roles: ['all'],
      },
      {
        id: '18-c',
        label: 'Videos',
        path: '/videos',
        roles: ['all'],
      },
      {
        id: '18-d',
        label: 'Training',
        file: {
          href: 'https://s3.us-east-1.amazonaws.com/cdn.memegames.ai/downloads/challenge.pdf',
          download: 'challenge.pdf',
        },
        roles: ['all'],
      },
      {
        id: '18-e',
        label: 'FAQs',
        path: '/faqs',
        roles: ['all'],
      },
      {
        id: '18-f',
        label: 'MemeGames Blog',
        path: '/blog',
        roles: ['all'],
      },
      // {
      //   id: 'payout-training',
      //   label: 'Payout Training',
      //   file: {
      //     href: 'https://s3.us-east-1.amazonaws.com/cdn.memegames.ai/downloads/payout-training.mp4',
      //   },
      //   type: 'external',
      //   roles: ['all'],
      // },
      // 90 day gameplan
      {
        id: '90-day-gameplan',
        label: '90 Day Gameplan',
        file: {
          href: 'https://s3.us-east-1.amazonaws.com/cdn.memegames.ai/downloads/mg_90_day_gameplan.pdf',
        },
        type: 'external',
        roles: ['all'],
      },
      // {
      //   id: '18-i',
      //   label: 'W9 & W-8BEN forms',
      //   path: '/taxes',
      //   roles: ['all'],
      // },
    ],
  },
  {
    id: '14',
    label: 'Support',
    path: '/blog/post/enhancement-updates',
    roles: ['all'],
    icon: (focused, theme) => (
      <Icon name="Support" color={getColor(focused, theme)} width={16} height={16} />
    ),
  },
];

export const drawerItemPaths = drawerItems
  .reduce((items, item) => {
    if (item.children?.length > 0) {
      items.push(...item.children.map((child) => ({ path: child.path, label: child.label })));
    } else {
      items.push({ path: item.path, label: item.label });
    }

    return items;
  }, []);

export default drawerItems;
